import React, { useEffect, useState } from 'react';
import { StyleSheet, View, Text, ActivityIndicator } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import reportService from '../../services/reportService';
import ReportList from './ReportList';

/**
 * Componente para mostrar reportes recientes en el dashboard
 * @param {Object} props - Propiedades del componente
 * @param {number} props.limit - Número máximo de reportes a mostrar
 */
const RecentReports = ({ limit = 3 }) => {
  const navigation = useNavigation();
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Cargar reportes recientes
  useEffect(() => {
    const loadReports = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const data = await reportService.getEnterpriseReports({ limit });
        console.log('Reportes recientes cargados:', data);
        setReports(data);
      } catch (error) {
        console.error('Error al cargar reportes recientes:', error);
        setError('No se pudieron cargar los reportes recientes');
      } finally {
        setLoading(false);
      }
    };
    
    loadReports();
  }, [limit]);

  // Manejar la selección de un reporte
  const handleReportPress = (report) => {
    navigation.navigate('ReportDetail', { reportId: report.id });
  };

  // Manejar la acción de ver todos los reportes
  const handleViewAll = () => {
    navigation.navigate('Reports');
  };

  if (loading) {
    return (
      <View style={styles.container}>
        <View style={styles.header}>
          <Text style={styles.title}>{'Reportes Recientes'}</Text>
        </View>
        <View style={styles.loadingContainer}>
          <ActivityIndicator size="small" color="#3498db" />
          <Text style={styles.loadingText}>{'Cargando reportes...'}</Text>
        </View>
      </View>
    );
  }

  if (error) {
    return (
      <View style={styles.container}>
        <View style={styles.header}>
          <Text style={styles.title}>{'Reportes Recientes'}</Text>
        </View>
        <Text style={styles.errorText}>{error}</Text>
      </View>
    );
  }

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <Text style={styles.title}>{'Reportes Recientes'}</Text>
        <Text style={styles.viewAll} onPress={handleViewAll}>{'Ver todos'}</Text>
      </View>
      
      {reports.length === 0 ? (
        <Text style={styles.emptyText}>{'No hay reportes disponibles'}</Text>
      ) : (
        <View style={styles.reportListContainer}>
          <ReportList reports={reports} onReportPress={handleReportPress} />
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: 15,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 15,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#2c3e50',
  },
  viewAll: {
    color: '#3498db',
    fontSize: 14,
  },
  loadingContainer: {
    alignItems: 'center',
    padding: 20,
  },
  loadingText: {
    marginTop: 10,
    color: '#7f8c8d',
    fontSize: 14,
  },
  errorText: {
    color: '#e74c3c',
    fontSize: 14,
    textAlign: 'center',
    padding: 20,
  },
  emptyText: {
    textAlign: 'center',
    color: '#7f8c8d',
    fontStyle: 'italic',
    padding: 20,
  },
  reportListContainer: {
    flex: 1,
  }
});

export default RecentReports;